import { render } from "./masterClassItem.vue?vue&type=template&id=3c965222&scoped=true"
import script from "./masterClassItem.vue?vue&type=script&lang=js"
export * from "./masterClassItem.vue?vue&type=script&lang=js"

import "./masterClassItem.vue?vue&type=style&index=0&id=3c965222&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c965222"]])

export default __exports__